"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _Table = require("../Table.styles");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var container = function container(theme) {
  return /*#__PURE__*/(0, _react.css)("background-color:", theme.color.table.rowBg, ";box-shadow:0 1px 3px 0 rgba(", theme.color.monochrome.black_rgba, ", 0.15);padding-bottom:8px;border-bottom-left-radius:", _Table.borderRadius, ";border-bottom-right-radius:", _Table.borderRadius, ";&>*{border-radius:0;}" + (process.env.NODE_ENV === "production" ? "" : ";label:container;"));
};

var withFooter = process.env.NODE_ENV === "production" ? {
  name: "13y804q",
  styles: "border-bottom-left-radius:0;border-bottom-right-radius:0"
} : {
  name: "9lcsf3-withFooter",
  styles: "border-bottom-left-radius:0;border-bottom-right-radius:0;label:withFooter;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var skeletonContainer = function skeletonContainer(_ref) {
  var theme = _ref.theme,
      hasContainer = _ref.hasContainer,
      hasFooter = _ref.hasFooter;
  return /*#__PURE__*/(0, _react.css)(hasContainer && container(theme), ";", hasFooter && withFooter, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:skeletonContainer;"));
};

var styles = {
  skeletonContainer: skeletonContainer
};
exports.styles = styles;
//# sourceMappingURL=StatusHint.styles.js.map